<template>
  <div class="bar-box primary" :class="cssClasses" :style="{ height: boxHeight }">
    <div v-if="valueAboveBar" class="value" :class="{ bold: focused}">
      <span v-if="withSign">+</span><span v-if="unit">{{ unit }} </span>{{ formattedValue }}
    </div>
    <div class="bar" :style="_barStyles" :class="{ empty: value === 0 }"/>
    <div v-if="valueBelowBar" class="value" :class="{ bold: focused}">
      <span v-if="withSign">-</span><span v-if="unit">{{ unit }} </span>{{ formattedValue }}
    </div>
    <div v-if="secondaryValue" class="bar-box secondary">
      <div class="value" v-if="valueAboveSecondaryValueBar" :class="{ bold: focused}">
        <span v-if="withSign">+</span><span v-if="unit">{{ unit }} </span>{{ formattedSecondaryValue }}
      </div>
      <div class="bar" :style="_secondaryBarStyles"/>
    </div>
  </div>
</template>

<script>

import { formatAmountWithFraction } from '../../utils/formatters';

export default {
  name: 'BarGraphValueBar',
  props: {
    value: {
      type: Number,
      required: true,
    },
    valueHeight: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      required: false,
    },
    // displayed behind the main bar
    secondaryValue: {
      type: Number,
      required: false,
    },
    secondaryValueHeight: {
      type: Number,
      required: false,
    },
    cssClasses: {
      type: Object,
      required: false,
    },
    focused: {
      type: Boolean,
      default: false,
    },
    withSign: {
      type: Boolean,
      default: true,
    },
    unit: {
      type: String,
      required: false,
    },
  },
  computed: {
    isPositive() {
      return this.valueHeight >= 0;
    },
    valueAboveBar() {
      return this.isPositive && (!this.secondaryValue || this.secondaryValueHeight < this.valueHeight);
    },
    valueAboveSecondaryValueBar() {
      return this.isPositive && this.secondaryValue && this.secondaryValueHeight >= this.valueHeight;
    },
    valueBelowBar() {
      return !this.secondaryValue && !this.isPositive;
    },
    formattedValue() {
      return formatAmountWithFraction(this.value, this.value > 0 && this.value < 1 ? 1 : 0);
    },
    formattedSecondaryValue() {
      return this.secondaryValue && formatAmountWithFraction(this.secondaryValue,
        this.secondaryValue > 0 && this.secondaryValue < 1 ? 1 : 0);
    },
    _barStyles() {
      return this.getBarStyles(this.valueHeight);
    },
    _secondaryBarStyles() {
      return this.getBarStyles(this.secondaryValueHeight);
    },
    boxHeight() {
      return this.secondaryValueHeight > this.valueHeight ? `${this.secondaryValueHeight}px` : undefined;
    },
  },
  methods: {
    getBarStyles(barHeight) {
      const isZero = barHeight === 0;
      const isNegative = barHeight < 0;
      const height = isZero ? 0 : barHeight;
      return {
        height: `${isNegative ? -height : height}px`,
        borderRadius: isZero ? 0 : undefined,
        '--bar-color': this.color,
      };
    },
  },
};

</script>

<style lang="scss">
@import './bar-graph.styles';
</style>
